import React, { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import TableContainer from "./TableContainer";
import PatientLoader from "../../../common/PatientLoader";
import "./ClassEnrollmentsDataTableStyles.css";

import { useNavigate } from "react-router-dom";

const ClassEnrollmentsDataTable = ({ data, enrollmentsCount }) => {
  const navigate = useNavigate();
  const { opsLoading, classesLoading, classesError } = useSelector(
    (state) => state.ops
  );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!classesLoading && !classesError) {
      setLoading(false);
    }
  }, [classesLoading]);

  let renderColumns = [
    {
      Header: "Title",
      accessor: "Title",
      Cell: ({ cell }) => {
        return (
          <span style={{ textTransform: "capitalize" }}>{cell.value}</span>
        );
      },
    },
    {
      Header: "Instructor",
      accessor: "Instructor",
      Cell: ({ cell }) => {
        return (
          <span style={{ textTransform: "capitalize" }}>{cell.value}</span>
        );
      },
    },
    {
      Header: "Date",
      accessor: "created_at",
      sortType: (a, b) => {
        if (a === null || a === undefined || a === "" || a === "Not Available")
          return 1; // place null values at the bottom
        if (b === null || b === undefined || b === "" || b === "Not Available")
          return -1;
        return new Date(b?.values?.created) - new Date(a?.values?.created);
      },

      Cell: ({ cell }) => {
        return (
          <span style={{ textTransform: "capitalize" }}>
            {cell.value
              ? moment(cell.value).format("MMM Do, YYYY")
              : "Not Available"}
          </span>
        );
      },
    },
    {
      Header: "Time",
      accessor: "Time",
      sortType: (a, b) => {
        if (a === null || a === undefined || a === "" || a === "Not Available")
          return 1; // place null values at the bottom
        if (b === null || b === undefined || b === "" || b === "Not Available")
          return -1;
        return new Date(b?.values?.created) - new Date(a?.values?.created);
      },

      Cell: ({ cell }) => {
        return (
          <span style={{ textTransform: "capitalize" }}>
            {cell.value ? cell.value : "Not Available"}
          </span>
        );
      },
    },
    {
      Header: "Duration",
      accessor: "Duration",
      disableSortBy: true,
      Cell: ({ cell }) => {
        return <span>{cell.value}</span>;
      },
    },
    {
      Header: "Enrollments",
      accessor: (d) => d.id,
      disableSortBy: true,
      Cell: ({ cell }) => {
        return <span>{enrollmentsCount[cell.value] || "0"}</span>;
      },
    },
    {
      Header: "Actions",
      accessor: "id",
      disableSortBy: true,
      Cell: ({ cell }) => {
        return (
          <button
            onClick={() => navigate(`/ops/clinic/${cell.value}`)}
            className="primary-btn-small"
          >
            View
          </button>
        );
      },
    },
  ];

  const columns = useMemo(
    () => renderColumns,
    [opsLoading, loading, classesLoading]
  );

  return (
    <>
      {opsLoading || loading || classesLoading ? (
        <PatientLoader />
      ) : (
        <TableContainer columns={columns} data={data} />
      )}
    </>
  );
};

export default ClassEnrollmentsDataTable;
